import MonitoringSocket from "@/ws/modules/Monitoring.socket.js";
import RrhhSocket from "@/ws/modules/Rrhh.socket.js";

const GeneralSocket = (socket)=> {
    // Module monitoring
    MonitoringSocket(socket);

    // Module RRHH
    RrhhSocket(socket);

    // Tesoreria


    // Operaciones
}

export default GeneralSocket;